var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _rect3, _path7, _rect4, _rect5, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCulture05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.458984,
    y: 0.828125,
    width: 350,
    height: 233,
    fill: "#87B499"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263.067 63.1868C263.238 63.0604 263.446 62.9922 263.659 62.9922H267.802C268.015 62.9922 268.223 63.0606 268.395 63.1873L313.323 96.3151C313.579 96.5036 313.729 96.8024 313.729 97.12V100.394C313.729 100.946 313.282 101.394 312.729 101.394H218.732C218.18 101.394 217.732 100.946 217.732 100.394V97.056C217.732 96.738 217.884 96.439 218.14 96.2506L263.067 63.1868Z",
    fill: "#FFF5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268.57 63.3164L313.732 96.6666V101.445H284.933V96.602L268.57 63.3164Z",
    fill: "#E8BBB1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 222.533,
    y: 101.395,
    width: 86.3973,
    height: 4.80018,
    rx: 1,
    fill: "#FFF5F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222.533 101.395H308.931V103.795H222.533V101.395Z",
    fill: "#E8BBB1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.533 145.594C222.533 145.041 222.981 144.594 223.533 144.594H307.931C308.483 144.594 308.931 145.041 308.931 145.594V149.394H222.533V145.594Z",
    fill: "#D77964"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M246.531 144.594H307.929C308.482 144.594 308.929 145.041 308.929 145.594V149.394H284.93L246.531 144.594Z",
    fill: "#A84A36"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M217.732 150.391C217.732 149.838 218.18 149.391 218.732 149.391H312.729C313.282 149.391 313.729 149.838 313.729 150.391V157.991C313.729 158.543 313.282 158.991 312.729 158.991H218.732C218.18 158.991 217.732 158.543 217.732 157.991V150.391Z",
    fill: "#FFF5F3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 227.332,
    y: 106.191,
    width: 19.1994,
    height: 38.4014,
    fill: "#FFF5F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M227.332 106.191H246.531V132.592L227.332 115.792V106.191Z",
    fill: "#E8BBB1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 256.133,
    y: 106.191,
    width: 19.1994,
    height: 38.4014,
    fill: "#FFF5F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 284.93,
    y: 106.191,
    width: 19.1994,
    height: 38.4014,
    fill: "#FFF5F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M256.133 106.191H275.332V132.592L256.133 115.792V106.191Z",
    fill: "#E8BBB1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M284.93 106.191H304.129V132.592L284.93 115.792V106.191Z",
    fill: "#E8BBB1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulture05);
export default __webpack_public_path__ + "static/media/culture_05.7fff7735a6c38a60655508c0d16a8605.svg";
export { ForwardRef as ReactComponent };